import { HomeThermometerOutlineIcon } from './HomeThermometerOutlineIcon';

/**
 * author: Hans Böhm
 * id 2782AA6E-C46A-4CEC-B753-35768CA30163
 * name home-thermometer-outline
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-thermometer-outline.svg
 * tags
 * - Home Automation 
 */
export const HouseTemperatureOutlineIcon = HomeThermometerOutlineIcon;
export default HouseTemperatureOutlineIcon